<template>
    <div>
        <div class="vx-row ml-1 mt-3">
            <vs-button
                class="mt-2"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-plus"
                @click="handleCreate()"
                :disabled="!checkPermission('create')"
            >Create</vs-button>
            <vs-button
                class="mt-2 ml-2 pl-50"
                color="success"
                type="border"
                icon-pack="feather"
                icon="icon-upload"
                @click="handleImport()"
                :disabled="!checkPermission('create')"
            >Import</vs-button>
        </div>
        <div class="vx-row ml-1 mt-3">
            <div class="vx-row mb-6" style="width:70%">
                <div class="vx-col sm:w-1/4 w-full flex items-center">
                    <span>Source Warehouse</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <Warehouse
                        @selected="(val) => { this.selectedSrcWarehouse = val }"
                        :use-type="this.usage"
                    ></Warehouse>
                </div>
            </div>
            <div class="vx-row mb-6" style="width:70%">
                <div class="vx-col sm:w-1/4 w-full flex items-center">
                    <span>Dest. Warehouse</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <DestWarehouse
                        @selected="(val) => { this.selectedDestWarehouse = val }"
                        :use-type="this.usage"
                        :source-warehouse-id="(this.selectedSrcWarehouse) ? this.selectedSrcWarehouse.id : 0"
                    ></DestWarehouse>
                </div>
            </div>
            <div class="vx-row mb-6" style="width:70%">
                <div class="vx-col sm:w-1/4 w-full flex items-center">
                    <span>Transaction Date</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <Date :default="false" @selected="(val) => { this.transactionDate = val }"></Date>
                </div>
            </div>
            <div class="vx-row mb-6" style="width:70%">
                <div class="vx-col sm:w-1/4 w-full flex items-center">
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                    <vs-button color="primary" @click="handleFilter()">Filter</vs-button>
                </div>
            </div>
        </div>
        <div class="vx-row mt-3">
            <div class="vx-col w-full mb-base">
                <Table
                    :draw="draw"
                    :status="activeTab"
                    :transaction-date="transactionDate"
                    :source-warehouse-id="(this.selectedSrcWarehouse) ? this.selectedSrcWarehouse.id : 0"
                    :dest-warehouse-id="(this.selectedDestWarehouse) ? this.selectedDestWarehouse.id : 0"
                ></Table>
            </div>
        </div>
    </div>
</template>

<script>
import Warehouse from "./component/Warehouse.vue";
import DestWarehouse from "./component/DestWarehouse.vue";
import Date from "./component/Date.vue";
import Table from "./component/Table.vue";

export default {
    components: {
        Warehouse,
        DestWarehouse,
        Date,
        Table
    },
    data() {
        return {
            activeTab: "New",
            draw: 0,
            transactionDate: null,
            selectedSrcWarehouse: null,
            selectedDestWarehouse: null,
            usage: "filter",
        }
    },
    methods: {
        checkPermission(stat) {
            return this.$store.getters['user/hasPermissions'](stat);
        },
        handleCreate() {
            this.$router.push({
                name: this.$store.state.outbound.simpleSto.baseRouterName + "-create",
            });
        },
        handleImport() {
            this.$router.push({
                name: "outbound.inter-warehouse-import"
            })
        },
        handleFilter() {
            this.draw++;
        },
    }
}
</script>